import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? "bg-[#07080f]/95 backdrop-blur-md border-b border-white/5 shadow-lg" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/1acf6269-cd6d-4d47-beae-5f08d64d41ca.png"
            alt="MDLARK Logo"
            className="h-10 w-auto object-contain"
          />
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {[
            { label: "Food Tech", id: "food-tech" },
            { label: "Industrial Biotech", id: "industrial-biotech" },
            { label: "Wellness Wearables", id: "wellness-wearables" },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-base text-white/70 hover:text-[#00e5c8] transition-colors duration-200 tracking-wide whitespace-nowrap cursor-pointer"
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo("contact")}
            className="whitespace-nowrap text-base px-5 py-2 rounded-full border border-[#00e5c8]/60 text-[#00e5c8] hover:bg-[#00e5c8]/10 transition-all duration-200 cursor-pointer"
          >
            Contact Team
          </button>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden text-white cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`ri-${menuOpen ? "close" : "menu"}-line text-2xl`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#07080f]/98 backdrop-blur-md border-t border-white/5 px-6 py-6 flex flex-col gap-5">
          {[
            { label: "Sustainable Food Tech", id: "food-tech" },
            { label: "Industrial Biotech", id: "industrial-biotech" },
            { label: "Personal Wellness Wearables", id: "wellness-wearables" },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-left text-white/80 hover:text-[#00e5c8] text-base transition-colors cursor-pointer"
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo("contact")}
            className="whitespace-nowrap text-sm px-5 py-2 rounded-full border border-[#00e5c8]/60 text-[#00e5c8] w-fit cursor-pointer"
          >
            Contact Team
          </button>
        </div>
      )}
    </nav>
  );
}
